import React, { useState, useEffect } from "react";
import { Card, Typography } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space } from "antd";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import JournalEntryForm from "./components/JournalEntryForm";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";

const AddGLA0200 = (props) => {
  const { Text, Title } = Typography;

  return (
    <>
      <MainLayout isEnableRightSidebar={false}>
        <TopContent
          pageTitle={appLabel.newJournalEntry}
          pageItems={appStatic.newJournalEntryItems}
        />
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.journalEntrySetup}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <JournalEntryForm />
        </Card>
      </MainLayout>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddGLA0200);
